var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-preview",class:{'category': _vm.name != '' },style:({'background-color': _vm.name ? `#${_vm.backgroundHex}` : '#FFF'})},[_c('h2',{class:{'empty': _vm.name == ''},style:({'color': _vm.name ? `#${_vm.textHex}` : '#777'})},[_vm._v(" "+_vm._s(_vm.name ? _vm.name : 'Category Preview Will Appear Here')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }